import { ReqParams } from "../types";
import axiosInstance from "./axiosInstance";


export default class IndustryService {
  static async getList(params: ReqParams = {}) {
    const response = await axiosInstance.get("/admin/industries", params);
    return response.data;
  }
}


